import { Avatar } from 'flowbite-react';
import { useEffect, useState } from 'react';
import { revertPositionTitleV2, stringAvatar } from 'shared-utils';
import { generateCompanyLogoAvatarSrc } from 'src/utils/companyLogo';
import { CompanyDocument, OfflineDriveRoom } from 'types';
import DisplayRoom from '../DisplayRoom';
import { FaCheckCircle } from 'react-icons/fa';
import dayjs from 'dayjs';
const CompaniesDetails = ({
	companyName,
	role,
	logoUrl,
	companyUrl,
	offlineDriveRoom,
	isCompanyPresent,
	positionLabel,
	attendDriveDate,
}: {
	companyName: string;
	role: string;
	logoUrl?: string;
	companyUrl?: string;
	offlineDriveRoom: OfflineDriveRoom;
	isCompanyPresent: boolean;
	positionLabel?: string;
	attendDriveDate?: Date;
}) => {
	const [avatarImg, setAvatarImg] = useState('');
	const generateAvatar = async (data: CompanyDocument) => {
		const res = await generateCompanyLogoAvatarSrc(data?.logo || '', data?.url || '');
		setAvatarImg(res);
	};

	useEffect(() => {
		generateAvatar({ logo: logoUrl, url: companyUrl } as CompanyDocument);
	}, [logoUrl, companyUrl]);

	return (
		<div className="flex gap-0.5">
			<div className="min-w-[80px] relative rounded-full w-10">
				<Avatar
					rounded
					size="md"
					className="text-xl"
					img={avatarImg}
					placeholderInitials={stringAvatar(companyName?.trim()?.toUpperCase())}
				/>
			</div>
			<div className="flex flex-col whitespace-pre">
				<div className="flex gap-1 items-center">
					<p className="text-[#1C1C28] font-inter text-base font-medium">{companyName}</p>
					{isCompanyPresent ? (
						<span>
							<FaCheckCircle className="text-blue-500" />
						</span>
					) : null}
				</div>
				<div className="flex flex-col gap-[4px]">
					<p className="text-[#28293D] font-inter text-xs font-medium mt-[4px]">
						{revertPositionTitleV2(role)}
						{positionLabel ? ` (${positionLabel})` : ''}
					</p>
					<DisplayRoom offlineDriveRoom={offlineDriveRoom} />
					{attendDriveDate ? (
						<p className="text-[#28293D] font-inter text-xs font-medium">
							<span className="text-[#1C1C28] font-inter text-[12px] leading-[16px] font-[700]">Registered At: </span>
							{attendDriveDate ? dayjs(attendDriveDate).format('Do MMM YYYY, hh:mm A') : '-'}
						</p>
					) : null}
				</div>
			</div>
		</div>
	);
};
export default CompaniesDetails;
